import { useNavigate } from 'react-router-dom';

const MODULOS = [
  { icon: 'ti-calendar-event',  titulo: 'Agenda y turnos',        texto: 'Gestión completa de citas médicas, por médico y por servicio.' },
  { icon: 'ti-report-medical',  titulo: 'Historia clínica',       texto: 'Formulario 002/008 MSP, evolución SOAP, signos vitales y diagnósticos CIE-10.' },
  { icon: 'ti-microscope',      titulo: 'Laboratorio e imagen',   texto: 'Catálogo completo, resultados con rangos de referencia, informes en PDF.' },
  { icon: 'ti-receipt',         titulo: 'Facturación electrónica',texto: 'Integración directa con el SRI — firma, autorización y notas de crédito.' },
  { icon: 'ti-users-group',     titulo: 'Facturación independiente por médico', texto: 'Si tu centro tiene varios médicos, cada uno factura con su propio RUC y punto de emisión.' },
  { icon: 'ti-brand-whatsapp',  titulo: 'Chatbot por WhatsApp',   texto: 'Agendamiento y recordatorio de citas automatizado para tus pacientes.' },
  { icon: 'ti-sparkles',        titulo: 'Asistente clínico con IA',texto: 'Dictado por voz que redacta la evolución y sugiere diagnósticos.' },
  { icon: 'ti-device-mobile',   titulo: 'App móvil para médicos', texto: 'Agenda, historia y recetas desde el celular, con Face ID.' },
  { icon: 'ti-users',           titulo: 'Portal del paciente',    texto: 'Resultados de laboratorio accesibles desde un link seguro, sin cuenta.' },
  { icon: 'ti-pill',            titulo: 'Farmacia',               texto: 'Dispensación desde la receta, control de inventario y precios validados.' },
  { icon: 'ti-dental',          titulo: 'Odontograma',            texto: 'Odontograma interactivo por pieza y superficie, con historial de tratamientos.' },
];

const PLANES = [
  {
    nombre: 'CONSULTORIO', sub: '1 médico', precioMes: 20, precioAno: 200,
    features: ['Agenda y turnos', 'Historia clínica', 'Facturación electrónica SRI', 'Portal del paciente'],
  },
  {
    nombre: 'EQUIPO', sub: '2 a 3 médicos', precioMes: 38, precioAno: 380, recomendado: true,
    features: ['Todo lo de Consultorio', 'Laboratorio e imagenología', 'Asistente clínico con IA', 'App móvil para médicos', 'Notas de crédito'],
  },
  {
    nombre: 'CLÍNICA', sub: 'Multi-sede, sin límite práctico', precioMes: 90, precioAno: 900,
    features: ['Todo lo de Equipo', 'Varias sedes/clínicas', 'Chatbot de citas por WhatsApp', 'Soporte prioritario'],
  },
];

const WHATSAPP_NUMERO = '593987540707';
const WHATSAPP_MSJ = encodeURIComponent('Hola, quiero solicitar el demo de MediCloud para mi consultorio.');
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMERO}?text=${WHATSAPP_MSJ}`;

const CLIENTES = [
  { nombre: 'Dra. Sandra Culqui' },
  { nombre: 'OncoCare' },
  { nombre: 'NEUROMED' },
];

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#f4f7fa', fontFamily: 'inherit' }}>

      {/* ── Header ── */}
      <header style={{
        background: 'linear-gradient(145deg, #0d1f3c 0%, #1a3a5c 60%, #0d2d4a 100%)',
        padding: '18px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <svg width="36" height="36" viewBox="0 0 48 48">
            <ellipse cx="24" cy="22" rx="15" ry="11" fill="white"/>
            <ellipse cx="13" cy="26" rx="10" ry="8" fill="white"/>
            <ellipse cx="35" cy="27" rx="9" ry="7" fill="white"/>
            <rect x="7" y="22" width="30" height="9" fill="white"/>
            <rect x="19" y="12" width="9" height="20" rx="3" fill="#2196F3"/>
            <rect x="14" y="17" width="19" height="9" rx="3" fill="#2196F3"/>
          </svg>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#fff' }}>
            Medi<span style={{ fontWeight: 300, color: '#64B5F6' }}>Cloud</span>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" style={{
            background: '#25D366', color: '#fff', border: 'none', borderRadius: 8,
            padding: '9px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: 7, textDecoration: 'none',
          }}>
            <i className="ti ti-brand-whatsapp" style={{ fontSize: 16 }} aria-hidden="true" />
            Solicitar demo
          </a>
          <button onClick={() => navigate('/login')} style={{
            background: '#2196F3', color: '#fff', border: 'none', borderRadius: 8,
            padding: '9px 20px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
          }}>
            Entrar al demo
          </button>
        </div>
      </header>

      {/* ── Hero ── */}
      <section style={{
        background: 'linear-gradient(145deg, #0d1f3c 0%, #1a3a5c 60%, #0d2d4a 100%)',
        padding: '56px 32px 72px', textAlign: 'center',
      }}>
        <div style={{
          display: 'inline-block', background: 'rgba(33,150,243,0.15)', color: '#64B5F6',
          fontSize: 11, fontWeight: 700, letterSpacing: 1.5, padding: '5px 14px',
          borderRadius: 999, marginBottom: 18,
        }}>
          SISTEMA DE DEMOSTRACIÓN
        </div>
        <h1 style={{ fontSize: 34, fontWeight: 700, color: '#fff', margin: '0 0 12px', letterSpacing: -0.5 }}>
          El sistema clínico que crece con tu consultorio
        </h1>
        <p style={{ fontSize: 15, color: '#a8cce8', maxWidth: 560, margin: '0 auto 28px', lineHeight: 1.6 }}>
          Agenda, historia clínica, laboratorio, facturación electrónica y una app móvil
          para tus médicos — todo en un solo sistema, hecho a la medida de tu operación.
        </p>
        <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={() => navigate('/login')} style={{
            background: '#fff', color: '#0d1f3c', border: 'none', borderRadius: 9,
            padding: '13px 30px', fontSize: 14, fontWeight: 700, cursor: 'pointer',
            boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
          }}>
            Explorar el demo →
          </button>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" style={{
            background: '#25D366', color: '#fff', border: 'none', borderRadius: 9,
            padding: '13px 26px', fontSize: 14, fontWeight: 700, cursor: 'pointer',
            display: 'inline-flex', alignItems: 'center', gap: 8, textDecoration: 'none',
            boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
          }}>
            <i className="ti ti-brand-whatsapp" style={{ fontSize: 18 }} aria-hidden="true" />
            Solicitar demo por WhatsApp
          </a>
        </div>
      </section>

      {/* ── Módulos ── */}
      <section style={{ padding: '48px 32px', maxWidth: 1080, margin: '0 auto' }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#10233B', textAlign: 'center', marginBottom: 6 }}>
          Todo lo que necesita tu clínica, en un solo lugar
        </h2>
        <p style={{ fontSize: 13, color: '#6b7a8d', textAlign: 'center', marginBottom: 36 }}>
          Prueba cada módulo con datos de ejemplo — nada de lo que hagas aquí afecta un sistema real.
        </p>
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))', gap: 18,
        }}>
          {MODULOS.map((m) => (
            <div key={m.titulo} style={{
              background: '#fff', borderRadius: 14, padding: 20,
              border: '1px solid #e4e9ef', boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
            }}>
              <div style={{
                width: 40, height: 40, borderRadius: 10, background: '#e8f2fe',
                display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12,
              }}>
                <i className={`ti ${m.icon}`} style={{ fontSize: 19, color: '#2196F3' }} aria-hidden="true" />
              </div>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#10233B', marginBottom: 4 }}>{m.titulo}</div>
              <div style={{ fontSize: 12.5, color: '#6b7a8d', lineHeight: 1.5 }}>{m.texto}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Planes ── */}
      <section style={{ padding: '8px 32px 48px', maxWidth: 1080, margin: '0 auto' }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#10233B', textAlign: 'center', marginBottom: 6 }}>
          Un plan para cada tamaño de consultorio
        </h2>
        <p style={{ fontSize: 13, color: '#6b7a8d', textAlign: 'center', marginBottom: 36 }}>
          Sin costos de instalación. Paga anual y ahorra — el equivalente a casi 2 meses gratis.
        </p>
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20,
          alignItems: 'stretch',
        }}>
          {PLANES.map((p) => (
            <div key={p.nombre} style={{
              background: p.recomendado ? '#10233B' : '#fff',
              borderRadius: 16, padding: '26px 24px',
              border: p.recomendado ? 'none' : '1px solid #e4e9ef',
              boxShadow: p.recomendado ? '0 12px 32px rgba(13,31,60,0.25)' : '0 1px 3px rgba(0,0,0,0.04)',
              display: 'flex', flexDirection: 'column', position: 'relative',
            }}>
              {p.recomendado && (
                <div style={{
                  position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)',
                  background: '#2196F3', color: '#fff', fontSize: 10, fontWeight: 700,
                  letterSpacing: 1, padding: '5px 14px', borderRadius: 999,
                }}>
                  RECOMENDADO
                </div>
              )}
              <div style={{
                fontSize: 11, fontWeight: 700, letterSpacing: 1,
                color: p.recomendado ? '#64B5F6' : '#6b7a8d', marginBottom: 4,
              }}>
                {p.nombre}
              </div>
              <div style={{ fontSize: 13, color: p.recomendado ? '#a8cce8' : '#6b7a8d', marginBottom: 16 }}>
                {p.sub}
              </div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 2 }}>
                <span style={{ fontSize: 34, fontWeight: 700, color: p.recomendado ? '#fff' : '#10233B' }}>
                  ${p.precioMes}
                </span>
                <span style={{ fontSize: 13, color: p.recomendado ? '#a8cce8' : '#6b7a8d' }}>/mes</span>
              </div>
              <div style={{ fontSize: 12, color: p.recomendado ? '#7fa8c9' : '#9aa8b8', marginBottom: 18 }}>
                o ${p.precioAno} al año
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 9, marginBottom: 22, flex: 1 }}>
                {p.features.map((f) => (
                  <div key={f} style={{
                    display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 12.5,
                    color: p.recomendado ? '#dceaf7' : '#3a4a5c',
                  }}>
                    <i className="ti ti-check" style={{
                      fontSize: 14, color: p.recomendado ? '#64B5F6' : '#2196F3', marginTop: 1, flexShrink: 0,
                    }} aria-hidden="true" />
                    {f}
                  </div>
                ))}
              </div>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" style={{
                background: p.recomendado ? '#2196F3' : '#f0f4f8',
                color: p.recomendado ? '#fff' : '#10233B',
                border: 'none', borderRadius: 9, padding: '11px', fontSize: 13, fontWeight: 700,
                cursor: 'pointer', textAlign: 'center', textDecoration: 'none',
              }}>
                Solicitar este plan
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* ── Desarrollos personalizados ── */}
      <section style={{ padding: '8px 32px 56px' }}>
        <div style={{
          maxWidth: 1080, margin: '0 auto', background: '#10233B', borderRadius: 20,
          padding: '40px 36px', display: 'flex', flexWrap: 'wrap', gap: 28,
          alignItems: 'center', justifyContent: 'space-between',
        }}>
          <div style={{ maxWidth: 480 }}>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.5, color: '#64B5F6', marginBottom: 8 }}>
              ¿NECESITAS ALGO MÁS ESPECÍFICO?
            </div>
            <h3 style={{ fontSize: 21, fontWeight: 700, color: '#fff', margin: '0 0 10px' }}>
              También hacemos desarrollos personalizados
            </h3>
            <p style={{ fontSize: 13.5, color: '#a8cce8', lineHeight: 1.6, margin: 0 }}>
              Si tu operación tiene necesidades que este sistema no cubre todavía —integraciones,
              flujos propios, reportes a medida— lo construimos específicamente para ti.
            </p>
          </div>
          <div style={{
            background: '#1a3a5c', borderRadius: 12, padding: '18px 22px', minWidth: 220,
          }}>
            <div style={{ fontSize: 10, color: '#64B5F6', letterSpacing: 1.2, marginBottom: 10, fontWeight: 600 }}>
              CONVERSEMOS
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <i className="ti ti-phone" style={{ fontSize: 14, color: '#4da8e8' }} aria-hidden="true" />
              <span style={{ fontSize: 13, color: '#fff', fontWeight: 500 }}>+593 0987540707</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <i className="ti ti-mail" style={{ fontSize: 14, color: '#4da8e8' }} aria-hidden="true" />
              <span style={{ fontSize: 12.5, color: '#90CAF9' }}>jcaicedofix@gmail.com</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── Nuestros clientes ── */}
      <section style={{ padding: '8px 32px 56px', maxWidth: 1080, margin: '0 auto', textAlign: 'center' }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#10233B', marginBottom: 6 }}>
          Nuestros clientes
        </h2>
        <p style={{ fontSize: 13, color: '#6b7a8d', marginBottom: 32 }}>
          Centros y consultorios que ya operan y facturan con MediCloud.
        </p>
        <div style={{
          display: 'flex', justifyContent: 'center', alignItems: 'stretch', gap: 18, flexWrap: 'wrap',
        }}>
          {CLIENTES.map((c) => (
            <div key={c.nombre} style={{
              width: 200, background: '#fff', borderRadius: 14, padding: '24px 18px',
              border: '1px solid #e4e9ef', boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8,
            }}>
              <div style={{
                width: 44, height: 44, borderRadius: 10, background: '#e8f2fe',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <i className="ti ti-building-hospital" style={{ fontSize: 20, color: '#2196F3' }} aria-hidden="true" />
              </div>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#10233B', textAlign: 'center' }}>
                {c.nombre}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Footer ── */}
      <footer style={{ textAlign: 'center', padding: '20px 32px 32px', fontSize: 11, color: '#9aa8b8' }}>
        © {new Date().getFullYear()} MediCloud · Ecuador · Este es un entorno de demostración con datos ficticios
      </footer>

      {/* ── Botón flotante WhatsApp ── */}
      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" style={{
        position: 'fixed', bottom: 24, right: 24, width: 58, height: 58, borderRadius: '50%',
        background: '#25D366', display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 6px 20px rgba(37,211,102,0.45)', textDecoration: 'none', zIndex: 50,
      }} aria-label="Solicitar demo por WhatsApp" title="Solicitar demo por WhatsApp">
        <i className="ti ti-brand-whatsapp" style={{ fontSize: 28, color: '#fff' }} aria-hidden="true" />
      </a>
    </div>
  );
}
